export default class ConsultationFrequency {
  static validFrequencies = [
    "1-week",
    "2-week",
    "1-month",
    "2-month",
    "3-month",
    "4-month",
    "5-month",
    "6-month",
    "1-year",
    "2-year",
    "3-year",
    "5-year"
  ] as const;

  constructor(
    public key: string,
    public enabled: boolean,
    public frequency?: (typeof ConsultationFrequency)["validFrequencies"][number],
    public type?: "physical" | "psychiatric",
    public comment?: string
  ) {}
}
